export const brand = "RecursoPDF";
export const productName = "MegaPack Arteterapia +50 Técnicas";
export const price = "$16.990 ARS";
export const checkoutUrl = "https://coleccion-completa-arteterapia.impultienda.ar/checkout";

export const images = {
  hero: "https://cdn.magicpatterns.com/uploads/wB2oH8sjHYvBoRGJvg5DNY/Portada.webp",
  bundle: "https://cdn.magicpatterns.com/uploads/8i7Po6aA3RzBUWKNttMwfb/Portada-Coleccion-mas-Bonos.webp",
  template: "https://cdn.magicpatterns.com/patterns/generated-images/43c5c407-7fd2-425d-8c74-d948ae118365.jpg",
};

export const heroBenefits = [
  { icon: "palette", text: "Más de 50 técnicas creativas listas para realizar" },
  { icon: "brain", text: "Ejercicios orientados a explorar emociones, ansiedad, autoestima y autoconocimiento" },
  { icon: "printer", text: "Descarga los PDFs, imprímelos o utilízalos desde tu dispositivo" },
  { icon: "heart", text: "Actividades guiadas, incluso si nunca hiciste ejercicios de este tipo" },
  { icon: "gift", text: "Incluye 3 bonos adicionales" },
] as const;

export const exerciseAreas = [
  { icon: "palette", text: "Representar visualmente cómo te sientes" },
  { icon: "leaf", text: "Crear momentos de calma y desconexión" },
  { icon: "message", text: "Explorar pensamientos y emociones" },
  { icon: "heart", text: "Trabajar la percepción que tienes de ti" },
  { icon: "compass", text: "Reflexionar sobre tus necesidades y prioridades" },
  { icon: "sprout", text: "Reconocer recursos personales" },
  { icon: "pen", text: "Expresarte mediante escritura y dibujo" },
  { icon: "sparkles", text: "Explorar cambios y nuevas etapas" },
] as const;

export const templateTools = ["palabras", "dibujos", "símbolos", "formas", "colores"];

export const sampleExercises = [
  "El clima de mi mente",
  "Mi mochila emocional",
  "El jardín de la calma",
  "Garabato liberador",
  "Mi refugio seguro",
  "El árbol que me sostiene",
  "De la tormenta a la calma",
  "Mis círculos de control",
  "Respirar en colores",
  "Mi mapa interior",
  "Mi rueda de emociones",
  "Mis voces internas",
  "El iceberg de lo que siento",
  "Mi brújula personal",
];

export const activityPhotos = [
  {
    src: "https://cdn.magicpatterns.com/uploads/3uGL87SWhmkpM4wbT9A3Rq/Captura_Landing1.webp",
    title: "El jardín de la calma",
    alt: "Captura real de la actividad El jardín de la calma: jardín con cinco girasoles en blanco para completar",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/jcKGDwCCRow9AocJCSe8st/Captura_Landing2.webp",
    title: "El clima de mi mente",
    alt: "Captura real de la actividad El clima de mi mente: paisaje con nubes, sol y lago para completar",
  },
];

export const bonuses = [
  {
    label: "Bono #1",
    title: "Rutinas de 10 minutos para bajar la ansiedad",
    body: "Una colección complementaria de pequeñas prácticas creativas pensadas para esos momentos en los que quieres hacer una pausa y dedicar unos minutos a recuperar calma y atención. Perfectas para incorporar a tu rutina sin necesitar largas sesiones.",
    src: "https://cdn.magicpatterns.com/uploads/71ivDUGxiJy1CtuLpmu67C/Portada-Bono-1.webp",
  },
  {
    label: "Bono #2",
    title: "Guía de materiales económicos y alternativas",
    body: "No necesitas comprar materiales artísticos costosos para comenzar. Esta guía te muestra opciones accesibles y alternativas con elementos que probablemente ya tengas en casa. Más creatividad. Menos complicaciones.",
    src: "https://cdn.magicpatterns.com/uploads/uyF1H3kNTm1YyL8o2HPqVH/Portada-Bono-2.webp",
  },
  {
    label: "Bono #3",
    title: "Diario emocional con consignas guiadas",
    body: "Un diario complementario para continuar explorando tus emociones mediante preguntas, registros y consignas creativas. Ideal para acompañar las actividades del MegaPack y observar tu proceso con el paso del tiempo.",
    src: "https://cdn.magicpatterns.com/uploads/dYxXU6643FZWjTPMZkfnV2/Portada-Bono-3.webp",
  },
];

export const offerItems = [
  { label: "MegaPack Arteterapia +50 Técnicas", detail: "6 volúmenes de ejercicios y plantillas", main: true },
  { label: "Bono #1", detail: "Rutinas de 10 minutos para bajar la ansiedad", main: false },
  { label: "Bono #2", detail: "Guía de materiales económicos y alternativas", main: false },
  { label: "Bono #3", detail: "Diario emocional con consignas guiadas", main: false },
];

export const usageOptions = [
  { icon: "download", text: "Descargarlo y conservarlo en tus dispositivos." },
  { icon: "printer", text: "Imprimir las actividades que quieras completar a mano." },
  { icon: "repeat", text: "Volver a imprimir una plantilla cuando quieras repetir un ejercicio." },
  { icon: "smartphone", text: "Utilizarlo desde tu computadora, tablet o celular para consultar instrucciones y actividades." },
] as const;

export const faqs = [
  {
    q: "¿Qué recibiré exactamente al comprar?",
    a: "Recibirás el MegaPack Arteterapia +50 Técnicas de RecursoPDF, compuesto por los 6 volúmenes de la colección, más los tres bonos: Rutinas de 10 minutos para bajar la ansiedad, Guía de materiales económicos y alternativas y Diario emocional con consignas guiadas. Todo el material es digital.",
  },
  {
    q: "¿Cómo recibo el material?",
    a: "Una vez confirmado el pago mediante Mercado Pago, recibirás las indicaciones de acceso al contenido digital según el sistema de entrega configurado por RecursoPDF.",
  },
  {
    q: "¿Es un producto físico?",
    a: "No. Es un producto 100% digital. No recibirás libros ni materiales físicos por correo.",
  },
  {
    q: "¿Necesito experiencia en arte?",
    a: "No. Las actividades fueron diseñadas para poder realizarse sin conocimientos de dibujo, pintura o técnicas artísticas.",
  },
  {
    q: "¿Puedo imprimir las actividades?",
    a: "Sí. Los archivos están pensados para que puedas consultar digitalmente las actividades o imprimir las páginas que quieras completar a mano.",
  },
  {
    q: "¿Cómo puedo pagar?",
    a: "Actualmente aceptamos pagos exclusivamente mediante Mercado Pago. El precio del MegaPack es de $16.990 ARS.",
  },
  {
    q: "¿Esto reemplaza terapia psicológica?",
    a: "No. El MegaPack contiene recursos creativos de bienestar y autoexploración. No constituye psicoterapia, diagnóstico, tratamiento médico ni reemplaza la atención de profesionales de salud mental.",
  },
];
